import "@/user/common";
import { mapSetting, tabSetting } from "@/shared/page/map/_index";

const { type } = document.querySelector(".map").dataset; // hall or salon
const hallMap = document.getElementById("hall_map"); // 会場地図要素
const salonMap = document.getElementById("salon_map"); // サロン地図要素

document.addEventListener("DOMContentLoaded", () => {
  // 初期表示
  mapSetting(type, hallMap, salonMap);
  tabSetting(type);

  // タブ切り替え
  document.querySelectorAll("#tabs--map li").forEach((el) => {
    el.addEventListener("click", (e) => {
      const clickType = e.currentTarget.dataset.click_type;
      mapSetting(clickType, hallMap, salonMap);
      tabSetting(clickType);
    });
  });

  // サロンのページ内スクロール
  document.querySelectorAll(".map-navi__link").forEach((mapNav) => {
    mapNav.addEventListener("click", (e) => {
      const salonId = e.currentTarget.dataset.salon_id; // 選択されたサロンID
      const headerElement = document.querySelector(".l-header");
      const headerStyles = window.getComputedStyle(headerElement);
      const headerHeight =
        headerElement.offsetHeight +
        parseFloat(headerStyles.marginTop) +
        parseFloat(headerStyles.marginBottom);
      const salonElement = document.getElementById(`${salonId}`);
      const salonElementPosition =
        salonElement.getBoundingClientRect().top + window.scrollY;
      const scrollPosition = salonElementPosition - headerHeight - 50; // スクロール位置（要素 - ヘッダー - 50px)
      window.scrollTo({
        top: scrollPosition,
      });
    });
  });
});
